export default __webpack_public_path__ + "static/media/7c.3210b3e0.svg";